<template>
  <div>
    <Loader :isLoading="isLoading_adminQuestions" />
    <Header v-if="!this.$store.getters.iframeColidee" :window="window" :parameters="'adminQuestionsPage'" />
    <div :class="!this.$store.getters.iframeColidee ? window.width < 480 ? 'container-fluid' : 'container' : 'p-3'">
      <ButtonReturnColidee v-if="this.$store.getters.iframeColidee"/>
      <PreviousResponseMessage :window="window"/>
      <ListButtons />
      <QuestionsComponent />
    </div>
    <MyFooter v-if="!this.$store.getters.iframeColidee" :window="window" />
  </div>
</template>

<script>
import Header from '@/components/layout/Header'
import Loader from '@/components/layout/Loader'
import MyFooter from '@/components/layout/MyFooter'
import PreviousResponseMessage from '@/components/question/components/PreviousResponseMessage'
import ListButtons from '@/components/question/components/ListButtons'
import QuestionsComponent from '@/components/question/QuestionsComponent'
import ButtonReturnColidee from '@/components/button/ButtonReturnColidee'
import { mapGetters } from 'vuex'

export default {
  components: {
    Header,
    Loader,
    MyFooter,
    PreviousResponseMessage,
    QuestionsComponent,
    ListButtons,
    ButtonReturnColidee
  },
  data () {
    return {
      window: {
        width: window.innerWidth
      }
    }
  },
  computed: {
    ...mapGetters(['isLoading_adminQuestions'])
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  updated () {
    this.sendMessageToParent('scrollToTop')
    this.$nextTick(function () {
      let message = {
        height: document.body.scrollHeight
      }
      window.top.postMessage(message, '*')
    })
  },
  created () {
    this.handleResize()
  },
  methods: {
    sendMessageToParent (taskToDo) {
      let message = {
        task: taskToDo
      }
      window.top.postMessage(message, '*')
    },
    handleResize () {
      this.window.width = window.innerWidth
      let message = {
        height: document.body.scrollHeight
      }
      window.top.postMessage(message, '*')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page/AdminQuestions.vue